import { selectRecentStaySearches as e } from "./selectRecentStaySearches.mjs";
import { useRecentSearchesQuery as t } from "./useRecentSearchesQuery.mjs";
//#region src/recentSearches/useRecentStaySearches.ts
var n = [], r = () => {
	let { data: r } = t();
	return r ? e(r.items) : n;
};
//#endregion
export { r as useRecentStaySearches };
